export * from "ce/pages/UserAuth/Login";
import * as CE_Login from "ce/pages/UserAuth/Login";
export default CE_Login.default;
